import {createAction} from '@reduxjs/toolkit'

export const updateModal = createAction('modal/save', (data) => ({
  payload: data
}))

export const clearModal = createAction('modal/clear')
